export default {
      id: "new-user-usage",
      viewBox: "0 0 16.625 16.319",
      url: "/dist/svg/" + "sprite.svg#new-user-usage",
      toString: function () {
        return this.url;
      }
    }